var _rect, _path, _circle, _circle2, _path2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFD663"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07406 14.5C1.02508 14.9934 1 15.4938 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 15.4937 30.9749 14.9934 30.9259 14.5C30.1733 22.08 23.778 28 16 28C8.22198 28 1.82665 22.08 1.07406 14.5Z",
    fill: "#FFD04C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 16.5,
    r: 2.5,
    fill: "#FF759B",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 16.5,
    r: 2.5,
    fill: "#FF759B",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6838 19.0513C12.2077 18.8767 12.774 19.1598 12.9487 19.6838C13.3511 20.891 14.4356 22 16 22C17.5644 22 18.6489 20.891 19.0513 19.6838C19.226 19.1598 19.7923 18.8767 20.3162 19.0513C20.8402 19.226 21.1233 19.7923 20.9487 20.3162C20.3511 22.109 18.6461 24 16 24C13.3539 24 11.6489 22.109 11.0513 20.3162C10.8767 19.7923 11.1598 19.226 11.6838 19.0513Z",
    fill: "#52565F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13,
    r: 2,
    fill: "#52565F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 13,
    r: 2,
    fill: "#52565F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendly);
export default __webpack_public_path__ + "static/media/friendly.50a18dc5c1bd2e8dd79767ab94c6639e.svg";
export { ForwardRef as ReactComponent };